<template>
<!-- Mobile button -->
<i class="mobile-nav-toggle d-lg-none">
    <i class="fa-solid fa-bars"></i>
</i>

<header id="header" class="d-flex flex-column justify-content-center">
    <nav id="navbar" class="navbar nav-menu">
        <ul>
            <li>
                <a href="#inicio" class="nav-link scrollto active">
                    <i class="fa-solid fa-house"></i> <span>Inicio</span>
                </a>
            </li>
            <li>
                <a href="#about" class="nav-link scrollto">
                    <i class="fa-regular fa-user ms-1"></i> <span>Sobre mi</span>
                </a>
            </li>
            <li>
                <a href="#resume" class="nav-link scrollto">
                    <i class="fa-regular fa-note-sticky"></i><span>Resumen</span>
                </a>
            </li>
            <li>
                <a href="#skills" class="nav-link scrollto">
                    <i class="fa-solid fa-server"></i> <span>Skills</span>
                </a>
            </li>
            <li>
                <a href="#proyectos" class="nav-link scrollto">
                    <i class="fa-regular fa-file-lines"></i><span>Proyectos</span>
                </a>
            </li>
            <li>
                <a href="#contacto" class="nav-link scrollto">
                    <i class="fa-regular fa-envelope"></i><span>Contacto</span>
                </a>
            </li>
        </ul>
    </nav>
</header>

<!-- Info -->
<info />

<a href="#" class="back-to-top d-flex align-items-center justify-content-center">
    <i class="fa-solid fa-chevron-up text-white"></i>
</a>
<main id="main">
    <!-- About -->
    <about />
    <!-- Resumen -->
    <resumen />
    <!-- Skills -->
    <skills />
    <!-- Proyectos -->
    <projects />
    <!-- Contacto -->
    <contact />
</main>

<div class="d-flex d-flex justify-content-end bd-highlight me-4">
    <div class="p-2 bd-highlight text-center me-2">
        <a href="https://www.linkedin.com/in/larh1/" target="_blank" class="">
            <img src="https://www.svgrepo.com/show/452047/linkedin-1.svg" height="40" alt="linkedin">
        </a>
    </div>
    <div class="p-2 bd-highlight text-center me-2">
        <a href="https://github.com/larh1/" class="" target="_blank">
            <img src="https://www.svgrepo.com/show/512317/github-142.svg" height="40" alt="github">
        </a>
    </div>
    <div class="p-2 bd-highlight text-center me-2">
        <a href="mailto: angel.rh.2108@gmail.com">
            <img src="https://www.svgrepo.com/show/421616/email-mail-web.svg" height="40" alt="email">
        </a>
    </div>
</div>
<footer id="footer">
    By: -LARH &copy; - {{new Date().getFullYear()}}
</footer>

<!-- TODO: Arreglar -->
<div id="preloader" v-show="loading"></div>
</template>

<script>
import
{
    defineAsyncComponent
}
from 'vue'
import contact from "@/components/contact.vue";
export default
{
    name: "main-home",
    data()
    {
        return {
            loading: true,
        }
    },
    components:
    {
        Info: defineAsyncComponent(() => import("@/components/Info.vue")),
        About: defineAsyncComponent(() => import("@/components/about.vue")),
        Resumen: defineAsyncComponent(() => import("@/components/resumen.vue")),
        Skills: defineAsyncComponent(() => import("@/components/skills.vue")),
        Projects: defineAsyncComponent(() => import("@/components/projects.vue")),
        Contact: contact
    },
    methods:
    {

    },
    mounted()
    {
        this.loading=false;
    }
}
</script>
